import React from "react"
import Particles from "react-particles-js"
import styled from "@emotion/styled"

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 800px;
  display: flex;
  align-items: center;
  #tsparticles {
    height: 800px;
  }
`
const ParticleContainer = styled.div`
  background: ${props => props.theme.primary};
  position: relative;
  height: 800px;
  #tsparticles {
    height: 800px;
  }
`

const Outer = styled.div`
  grid-column: span 3;
  display: inline-grid;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  width: 100%;
  position: absolute;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
    align-items: center;
  }
`
const Inner = styled.div`
  color: ${props => props.textColor};
  grid-column: 2 / 3;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 64px;
  justify-content: center;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: block;
    > * + * {
      margin-top: 32px;
    }
  }
`
const Card = styled.div`
  padding: 32px;
  border-radius: 8px;
  background-color: ${props => props.theme.shade[100]};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  height: 100%;
  p:last-of-type {
    margin-bottom: 0;
  }
`

export default function SplitFeature(props) {
  return (
    <ParticleContainer>
      <Container>
        <Outer>
          <Inner>
            <Card data-sal="fade" data-sal-duration="600">
              {props.left}
            </Card>
            <Card data-sal="fade" data-sal-duration="600">
              {props.right}
            </Card>
          </Inner>
        </Outer>
      </Container>
      <Particles
        params={{
          particles: {
            number: { value: 8, density: { enable: true, value_area: 1200 } },
            color: { value: "#fe7d88" },
            shape: {
              type: "polygon",
              stroke: { width: 0, color: "#000000" },
              polygon: { nb_sides: 7 },
              image: {
                src: "https://svgur.com/i/Lzj.svg,width:100,height:100",
              },
            },
            opacity: {
              value: 0.1,
              random: true,
              anim: {
                enable: false,
                speed: 0.4,
                opacity_min: 0.1,
                sync: false,
              },
            },
            size: {
              value: 120,
              random: false,
              anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
            },
            line_linked: {
              enable: false,
            },
            move: {
              enable: true,
              speed: 6,
              direction: "none",
              random: true,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: { enable: false, rotateX: 600, rotateY: 1200 },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: false },
              onclick: { enable: false },
              resize: true,
            },
            modes: {
              grab: { distance: 400, line_linked: { opacity: 1 } },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: { distance: 200, duration: 0.4 },
              push: { particles_nb: 4 },
              remove: { particles_nb: 2 },
            },
          },
        }}
        style={{
          width: "100%",
        }}
      ></Particles>
    </ParticleContainer>
  )
}
